import React, { useMemo } from 'react';
import { Avatar, Box, Typography } from '@material-ui/core';
import getInitials from 'src/utils/getInitials';
import { formatDisplayPhone } from 'src/modules/phones/utils/formatDisplayPhone';
import { ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

export const ContactInformation = ({
    name,
    image,
    phone,
    normalizedPhone,
    contactCountryCode,
    storeCountryCode,
}: {
    name: string;
    image: string;
    phone: string;
    normalizedPhone?: string;
    contactCountryCode?: ECountryCode;
    storeCountryCode?: string;
}) => {
    const formattedPhone = useMemo(
        () =>
            formatDisplayPhone(normalizedPhone || phone, {
                countryCode: contactCountryCode,
                fallbackCountryCode:
                    (storeCountryCode as ECountryCode) || ECountryCode.Mexico,
            }),
        [normalizedPhone, phone, contactCountryCode, storeCountryCode]
    );
    return (
        <Box
            style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 10,
            }}
        >
            <Avatar src={image} style={{ width: 200, height: 200 }}>
                {getInitials(name)}
            </Avatar>
            <Typography variant="h2" color="textPrimary">
                {name}
            </Typography>
            <Typography variant="body1" color="textSecondary">
                {formattedPhone}
            </Typography>
        </Box>
    );
};
